export default __webpack_public_path__ + "static/media/bg-paddy.e729bd76.jpg";